import session from '@/shared/session'
import downloadjs from 'downloadjs'
import { v5 as uuidv5 } from 'uuid'

// initial state
const state = {
	namespaces: {
		patients: '2bc79d07-abc2-45cd-a6ff-8da058f6e8d3',
		diabetes: '6802dab7-7cc7-4fb7-9262-e6fa31897888',
		procedures: '16405953-b77d-408d-9f43-4c49fb0176c4',
		attests: '48217257-8827-4a28-9f27-6084095ccc61'
	}
}

// getters
const getters = {
	getIdentifier: (state) => (key, name) => {
      return state.namespaces.hasOwnProperty(key) ? uuidv5(name, state.namespaces[key]) : null
    }
}

// actions
const actions = {
	async downloadExport({ commit, state, rootState }, id) {
		const download = await session
			.get(`/api/interchange/exports/${id}/download/`)
		
		const { content, filename, mime_type } = download.data
      	downloadjs(content, filename, mime_type)

      	return true
	},
	async downloadExportBatch({ commit, state, rootState }, id) {
		const download = await session
			.get(`/api/interchange/exports/batch/${id}/download/`)
		
		const { content, filename, mime_type } = download.data
      	downloadjs(content, filename, mime_type)

      	return true
	},

}

// mutations
const mutations = {

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}